var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoading),expression:"showLoading"}],staticClass:"ui-loading"},[_c('div',{staticClass:"loading-content"},[_c('i',{staticClass:"icon-loading"}),_c('span',[_vm._v(_vm._s(_vm.loadingDesc))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }